import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import LicenseRecommendChips from '@/components/format-edit/LicenseRecommendChips.vue'
import {
  useRirekishoFormatData,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'
import { useRirekishoHistoriesApi } from '@/composables/format-edit/useRirekishoHistories'
import type { BasicData } from '@/utils/format-edit/basicData'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoLicenseCard',
  props: {
    currentCardId: null,
    formatId: null,
    basicData: null,
    previewErrors: null,
    exampleSentences: null
  },
  setup(__props: any) {

const descriptionMaxLength = 80



const formatData = useRirekishoFormatData()
const {
  activeHistoryItem,
  addLicenseHistory,
  deleteLicenseHistory,
  moveLicenseHistory,
  activateHistoryItem
} = useRirekishoHistoriesApi()

const enteredLicenses = computed(() =>
  formatData.licenseHistories.map((item) => item.description || '')
)

// 空の行があればそこへ入れ、無ければ行を足す
function onSelectRecommend(description: string) {
  const empty = formatData.licenseHistories.find((item) => !item.description)
  if (empty) empty.description = description
  else addLicenseHistory(null, { description })
}

return { __sfc: true,descriptionMaxLength, formatData, activeHistoryItem, addLicenseHistory, deleteLicenseHistory, moveLicenseHistory, activateHistoryItem, enteredLicenses, onSelectRecommend, HistoryItem, LicenseRecommendChips }
}

})